import React from "react";
import styled from "@emotion/styled";
import BachelorsImage from "../../../assets/education/Bachelor's.png";
import MastersImage from "../../../assets/education/Bachelor's.png";
import SeniorHighSchool from "../../../assets/education/Senior High School.png";
import JuniorHighSchool from "../../../assets/education/Junior High School.png";
import Elementary from "../../../assets/education/Elementary.png";
type TimelineItem = {
  time: string;
  title: string;
  description: string;
  image?: string;
};
interface Props {
  theme: number;
}

const timelineData: TimelineItem[] = [
  {
    time: "Elementary School (2007 - 2015)",
    title: "Anuban Kudchum Phatthana (Sriwisan Rangsan) School",
    description: "",
    image: Elementary,
  },
  {
    time: "Junior High School (2015 - 2018)",
    title: "Kutchumwittayakom School",
    description: "Science - Math",
    image: JuniorHighSchool,
  },
  {
    time: "Senior High School (2018 - 2021)",
    title: "Princess Chulabhorn Science High School Mukdahan",
    description: "Science - Math",
    image: SeniorHighSchool,
  },
  {
    time: "Bachelor's Degree (2021 - 2025)",
    title: "King Mongkut’s University of Technology Thonburi",
    description: "Bachelor of Science (Applied Computer Science)",
    image: BachelorsImage,
  },
  {
    time: "Master's Degree (2025 - Present)",
    title: "King Mongkut’s University of Technology Thonburi",
    description: "Master of Science (Applied Mathematics)",
    image: MastersImage,
  },
];

const Timeline: React.FC<Props> = (props) => {
  return (
    <TimelineContainer>
      <CenterLine />
      {timelineData.map((item, index) => {
        const isLeft = index % 2 === 0;
        return (
          <TimelineItemContainer key={index}>
            {isLeft ? (
              <>
                <TimelineContent>
                  {renderCard(item, props.theme)}
                </TimelineContent>
                <Connector>
                  <Dot />
                  <LineConnector isLeft={true} />
                </Connector>
                <EmptySpace />
              </>
            ) : (
              <>
                <EmptySpace />
                <Connector>
                  <Dot />
                  <LineConnector isLeft={false} />
                </Connector>
                <TimelineContent>
                  {renderCard(item, props.theme)}
                </TimelineContent>
              </>
            )}
          </TimelineItemContainer>
        );
      })}
    </TimelineContainer>
  );
};

export default Timeline;

const renderCard = (item: TimelineItem, theme: number) => (
  <Card theme={theme}>
    <BoxFlex>
      {item.image && <CardImage src={item.image} alt={item.title} />}
      <Time theme={theme}>{item.time}</Time>
    </BoxFlex>
    <Title>{item.title}</Title>
    <Description theme={theme}>{item.description}</Description>
  </Card>
);

const TimelineContainer = styled("div")({
  position: "relative",
  padding: "40px 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "80vw",
});

const CenterLine = styled("div")({
  position: "absolute",
  width: "2px",
  backgroundColor: "#ccc",
  top: 0,
  bottom: 0,
  left: "50%",
  transform: "translateX(-50%)",
});

const TimelineItemContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  maxWidth: "900px",
  margin: "20px 0",
  position: "relative",
  //   border: "2px solid",
});

const TimelineContent = styled("div")({
  width: "40%",
});

const EmptySpace = styled("div")({
  width: "40%",
});

const Connector = styled("div")({
  position: "relative",
  width: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const Dot = styled("div")({
  width: "12px",
  height: "12px",
  backgroundColor: "#909090",
  borderRadius: "50%",
  zIndex: 2,
});

const LineConnector = styled("div")<{ isLeft: boolean }>(({ isLeft }) => ({
  position: "absolute",
  height: "2px",
  width: "50px",
  backgroundColor: "#8888",
  top: "50%",
  transform: "translateY(-50%)",
  left: isLeft ? "auto" : "100%",
  right: isLeft ? "100%" : "auto",
  "@media (max-height: 600px)": {
    width: "30px",
  },
}));

const Card = styled("div")<Props>(({ theme }) => ({
  backgroundColor: theme === 1 ? "#fff" : theme === 2 ? "#fff" : "#000",
  padding: "16px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  color: theme === 1 ? "#000" : theme === 2 ? "#000" : "#fffff0",
  //   display: "flex",
}));
const BoxFlex = styled("div")({
  display: "flex",
  gap: "5px",
});

const Time = styled("div")<Props>(({ theme }) => ({
  fontSize: "0.9rem",
  color: theme === 1 ? "#888" : theme === 2 ? "#888" : "#d3d3d3",
  marginBottom: "4px",
}));

const Title = styled("div")({
  fontSize: "1.2rem",
  fontWeight: "bold",
  marginBottom: "8px",
});

const Description = styled("div")<Props>(({ theme }) => ({
  fontSize: "1rem",
  color: theme === 1 ? "#444" : theme === 2 ? "#444" : "#999",
}));
const CardImage = styled("img")({
  width: "16px",
  height: "16px",
  borderRadius: "50%",
  objectFit: "contain",
  backgroundColor: "#fff",
});
